import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetailsv2 from '../../../iptrackerdetails'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: 'register',
    components: {
        VueElementLoading,
        Multiselect
    },
    data: function() {
        return {
            userid: '',
            useraction: 'add',
            NoticePeriod: '',
            listProjectData: [],
            listHubZoneData: [],
            listHubData: [],
            listHubsData: [],
            confirmpassword: '',
            iptrackData:'',
            props: [],
            localuserid: 0,
            stateList: [],
            cityList: [],
            listUserTypeData: [],
            clientList: [],
            hubServiceCenterList: [],
            EmployeeTypeData: [],
            EmployeeCategoryData: [],
            OutsourcingData: [],
            ParentUserData: [],
            ReportingUserData: [],
            vendorList: [],
            designationList: [],
            departmentList: [],
            empTypeList: [],
            empCategoryList: [],
            projectRoles: [],
            roles:[],
            show:'',
            hub_zone_test: [],
            hub_zone:{
              hubzoneid:  []
            },
            userDetails:{
              username:'',
              utype:'',
              roleid:'',
              status:true,
              Sex:'',
              MiddleName:'',
              EmployeeID:'',
              NoticePeriod:'',
              StateId:'',
              CityId:'',
              clientid:'',
              //VendorId:'',
              DepartmentID:'',
              //ParentUserID:'',
              ReportingUserID:'',
              DesignationID:'',
              OutSourcingID:'',
              HubId:null,
              EmpType:'',
              PositionType:'',
              DateOfRelieving:'',
              EmployeeCategory:'',
              TShirtSize:'',
              ShiftTimings:'',
              WeeklyOff:'',
              Comment:'',
              VehicleNo:'',
              temphub:'',
              IsActiveReportAdmin:''
            },
            form: {
                projectidwiserole: [],
                projectidwisemultirole: [],
                projectidwisezone: [],
                projectidwisehubs: [],
                values:[],
                value: [],
                projectidchk:[],
                // proSel:''
            },
            selectedFile:'',
            s3bucketFileList: [],
            DelUserPhotoScanFiles: '',
            DelUserLicenceScanFiles: '',
            DlvUserPoliceVerificationScanFiles: '',
            DlvUserAadhaarCardVerificationScanFiles: '',
            DlvUserPANCardVerificationScanFiles: '',
            isActive: false,
            updatedRole:[]
        }
    },
    created: function() {
    },
    async mounted() {

        // if(!global.hubServiceCenterList){
        //   let data= await this.getHubServiceCenterData();
        //   this.hubServiceCenterList=data;
        // }else{
        //   this.hubServiceCenterList=global.hubServiceCenterList;
        // }

        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        //iptrackerdetails.checkUserIP(this.iptrackData,'Projects Access Application User',this.$route.path,);
        let iptrck= await iptrackerdetailsv2.checkUserIPV2(this.iptrackData,'Projects Access Application User',this.$route.path);
        //console.log(iptrck);
        if(iptrck){
          this.$router.push('/');
        }

        this.localuserid = userdetail.userid;
        this.localusermailid = userdetail.email;

        this.pageno = 0;
      //  this.getUserTypeData();

        if(this.$route.params.id==undefined){
          this.$router.push('/user');
        }else{
          var userid = this.$route.params.id;
          this.getUserData(userid);
          this.getHubZoneData();
        }
    },
    methods: {
        verify_doj(){
          var birthdate = new Date($("#DateOfBirth").val());
          var joinDate = new Date($("#DateOfJoining").val());

          if (joinDate.getFullYear() - birthdate.getFullYear() < 18){
            alert('You Are Not 18 Year');
          }
        },
        setname(projectid){
          return 'projectroleid'+projectid;
        },
        setrolename(projectid){
          return 'projectmultiroleid'+projectid;
        },
        sethubzonename(projectid){
          return 'projecthubzoneid_'+projectid;
        },
        sethubname(projectid){
          return 'projecthubid'+projectid;
        },
        showProjectName(project_id){
          let showitem = document.getElementById("projectlistitem_"+project_id).getAttribute("show");
          if(showitem == 0){
            document.getElementById("projectaccess_"+project_id).classList.remove("hideProject");
            document.getElementById("arrow_"+project_id).classList.remove("fa-angle-right");
            document.getElementById("projectaccess_"+project_id).classList.add("showProject");
            document.getElementById("arrow_"+project_id).classList.add("fa-angle-down");
            document.getElementById("projectlistitem_"+project_id).setAttribute("show",1)
            document.getElementById("projectlistitem_"+project_id).style.backgroundColor ="#4b8cbb";
          }

          if(showitem ==1){
            document.getElementById("projectaccess_"+project_id).classList.remove("showProject");
            document.getElementById("arrow_"+project_id).classList.remove("fa-angle-down");
            document.getElementById("projectaccess_"+project_id).classList.add("hideProject");
            document.getElementById("arrow_"+project_id).classList.add("fa-angle-right");
            document.getElementById("projectlistitem_"+project_id).setAttribute("show",0)
            document.getElementById("projectlistitem_"+project_id).style.backgroundColor ="#e4e4e4";
          }
        },
        validateRole(projectid,event){
          if (event.target.checked)
          {
            this.$validator.attach('projectroleid'+projectid, 'required');
            document.getElementById('projectroleid'+projectid).disabled = false;
            this.form.projectidwisezone[projectid] = this.listHubZoneData;
            this.form.projectidwisehubs[projectid] = this.listHubData;
          }else{
            this.$validator.detach('projectroleid'+projectid);
            this.form.projectidwiserole[projectid]='';
            this.form.projectidwisemultirole[projectid]='';
            this.form.projectidwisezone[projectid] = [];
            this.form.projectidwisehubs[projectid] = [];
            this.listHubsData = [];
            document.getElementById('projectroleid'+projectid).disabled = true;
          }
          var checkedCount = $('input[name=projectid]:checkbox:checked').length;
          if(checkedCount>0){
            // this.form.proSel = projectid;
          }else{
            // this.form.proSel ="";
          }
        },
        removeValidation(projectroleid,projectallroles,projectid){
          var e = document.getElementById(projectroleid).value;
          if(e!=""){
            if(projectallroles.length > 0){
                this.$validator.detach(projectroleid);
            }else{
              this.$validator.attach(projectroleid, 'required');
            }
          }
        },
        bindroleid(projectid){
          var res = '';
            var selectedProjects = this.form.projectidchk;
            selectedProjects.forEach(function(k, v){
              if(v==projectid){
                res = k.roleid;
              }
            });
          return res;
        },
        multiple(){
          if(this.userDetails.utype==2){
            return true;
          }else{
            return false;
          }
        },
        closeRegistration(){
          this.$router.push('/user');
        },
        getUserData(userid) {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                userid: userid
            })

            this.show = true;
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'userDetails',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(async result => {
                  this.userid = result.data.userdetails.userid;
                  this.useraction = "edit";
                  this.userDetails = result.data.userdetails;
                  let projectRoles = result.data.projectdetails;
                  projectRoles.forEach((projects)=>{
                    this.form.projectidchk[projects.userroleaccessmaster_projectid]=true;
                  });

                  await this.getProjectData(projectRoles);
                  await this.getHubData();
                  this.show = false
                }, error => {
                    console.error(error)
                })
        },
        editUser(event) {
          this.show = true;
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            let tempArr=[];
            let projetct_id = event;
            let accessAttr = {}
               if(projetct_id){
                if(this.form.projectidwiserole[projetct_id]!=""){
                   accessAttr.isactive = true
                 }else{
                   accessAttr.isactive = false
                 }
                 if(this.form.projectidwiserole[projetct_id]!=""){
                   accessAttr.roles = this.form.projectidwiserole[projetct_id]
                 }
                 if(this.form.projectidwisezone[projetct_id]!=""){
                   accessAttr.zones = this.form.projectidwisezone[projetct_id]
                 }
                 if(this.form.projectidwisehubs[projetct_id]!=""){
                   accessAttr.hubs = this.form.projectidwisehubs[projetct_id]
                 }
                 if(this.form.projectidwisemultirole[projetct_id]!="" && this.form.projectidwisemultirole[projetct_id] && this.form.projectidwisemultirole[projetct_id] != undefined){

                  let multirole = this.form.projectidwisemultirole[projetct_id];
                  let defaultrole = this.form.projectidwiserole[projetct_id];
                  let finalmultirole=[];
                  Object.keys(multirole).map(function(key, index) {
                    if(multirole[key].roleid != defaultrole){
                      finalmultirole.push(multirole[key]);
                    }
                  });
                    accessAttr.multiroles = finalmultirole;
                }

                 accessAttr.projects = projetct_id
                 tempArr.push(accessAttr);
                }

                let reqpayload = {
                  userid: this.userid,
                  projectroleid: tempArr,
                  modifiedby: this.localusermailid
                }
            // this.input = ({
            //     userid: this.userid,
            //     projectroleid: tempArr,
            //     modifiedby: this.localusermailid
            // });
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'updateUserAccess',
                    'data': reqpayload,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then((response) => {
                    //event.target.reset();
                    this.$alertify.success(response.data.msg);
                    iptrackerdetailsv2.checkUserIP(this.iptrackData,'Update User projects Access',this.$route.path,reqpayload,response.data);
                    this.$router.push('/user');
                })
                .catch((httpException) => {
                    console.error('exception is:::::::::', httpException)
                })
        },
        getProjectData(selprojects="") {
          if(this.userDetails.utype==""){
            return false;
          }

          this.listProjectData=[];
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');
            this.input = ({
              usertype : this.userDetails.utype
            });
            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'getTypeWiseProjectRoleList',
                    data: this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listProjectData = result.data;
                    let projects = result.data;
                      projects.forEach((projectitem,key)=>{
                      let selectedroleid ="";
                      if(selprojects.length>0){
                        selprojects.forEach((roleitem,pkey)=>{
                           if(projectitem.project.projectid==roleitem.userroleaccessmaster_projectid){
                             selectedroleid = roleitem.userroleaccessmaster_roleid;
                             // this.form.proSel = selectedroleid;
                             selectedroleid = roleitem.userroleaccessmaster_roleid;
                             this.form.projectidwiserole[projectitem.project.projectid] = selectedroleid;
                             this.form.projectidwisezone[projectitem.project.projectid] = roleitem.userroleaccessmaster_zoneids;
                             this.form.projectidwisehubs[projectitem.project.projectid] = roleitem.userroleaccessmaster_hubs;
                              this.form.projectidwisemultirole[projectitem.project.projectid] = roleitem.userroleaccessmaster_multiroleid;
                             this.getHublistOfZone(roleitem.userroleaccessmaster_zoneids,'projecthubzoneid_'+projectitem.project.projectid);
                           }
                         });
                      }

                      this.form.projectidwiserole[projectitem.project.projectid] = selectedroleid;
                      //this.form.projectidwisemultirole[projectitem.project.projectid] = selectedroleid;
                    });
                }, error => {
                    console.error(error)
                })
        },
        getHubZoneData() {
          this.listHubZoneData=[];
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = ({
            apptoken : userToken
          });
          axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getHubZoneData',
                  data: this.input,
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              })
              .then(result => {
                if(result.msg!="failed")
                {
                  this.listHubZoneData = result.data;
                }
              }, error => {
                  console.error(error)
              })
        },
        getHubData() {
          this.listHubData=[];
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          this.input = ({
            apptoken : userToken,
            hubids : this.userDetails.temphub
          });
          axios({
                  method: 'POST',
                  'url': apiUrl.api_url + 'getHubData',
                  data: this.input,
                  headers: {
                      'Authorization': 'Bearer ' + myStr
                  }
              })
              .then(result => {
                if(result.msg!="failed")
                {
                  this.listHubData = result.data;
                }
              }, error => {
                  console.error(error)
              })
        },
        removeHubs(removedOption, pid){
          let project_id = pid.split("_");
          let finalHubIds = [];
          if(this.form.projectidwisehubs[project_id[1]].length > 0 ){
              this.form.projectidwisehubs[project_id[1]].forEach((item)=>{
                if(removedOption.hubzoneid!= item.HubZoneId)
                {
                  finalHubIds.push(item);
                }
              });
              this.form.projectidwisehubs[project_id[1]] = finalHubIds;
          }
        },
        getHublistOfZone(hubids,id) {
          this.show = true
          this.listHublistData = [];
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          let tempHubZoneArr=[];
          if(Array.isArray(hubids)){
            hubids.forEach(function(data, index) {
                tempHubZoneArr.push(data.hubzoneid);
            });
          }
          if(tempHubZoneArr.length > 0)
          {
            this.input = {
              "apptoken" : userToken,
              "hubzoneids" : tempHubZoneArr
            }
          axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getHublistOfZone',
                data: this.input,
                headers: {
                    'Authorization': 'Bearer ' + myStr
                }
              })
              .then(result => {
                  let project_id = id.split("_");
                  this.listHubsData = result.data;
                  $("#projecthubid"+project_id[1]).focus();
                  this.show = false;
              }, error => {
                  console.error(error)
              })
            }else{
              let project_id = id.split("_");
              this.listHubsData = [];
              this.form.projectidwisehubs[project_id[1]] = [];
              $("#projecthubid"+project_id).focus();
              this.show = false;
            }
        },
        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {

            if(result)
            {
              //event.target.reset();
              //console.log('form is valid');
              if(this.userid!=undefined && this.userid!="")
              {
                //console.log("Form ready to submit update user");
                this.editUser(event);
              }
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/accessprojects/accessprojects.component.js